import Storage from "../../utils/storage";

export function getStorageItem() {
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let img = user && user.logo;
  let compImg = user && user.company && user.company.logo;
  let username = user && user.first_name;
  let name = user && user.name;
  let type = user && user.type
  return { img, compImg, name, username, type };
}

export function getDecodedData() {
  let userData = Storage.get("decoded-data");
  const user = JSON.parse(userData);
  let email = user && user.email;
  let exp = user && user.exp;
  let iat = user && user.iat;
  let type = user && user.type;
  let userId = user && user.user_id
  return { email, exp, iat, userId, type };
}
